<template>
  <div class="min-h-screen bg-[#f6f7f9] py-10">
    <div class="max-w-[900px] mx-auto px-6">
      <div class="bg-white rounded-2xl border border-[#e9eaec] shadow-sm overflow-hidden">
        <div class="h-1 bg-gradient-to-r from-[#FFD500] to-[#FFC107]"></div>
        <div class="px-8 py-10">

          <nav class="flex items-center gap-2 text-[0.82rem] text-[#999] mb-6">
            <router-link to="/" class="hover:text-[#111] transition-colors no-underline"><i class="bi bi-house"></i></router-link>
            <i class="bi bi-chevron-right text-[0.7rem]"></i>
            <span class="text-[#111] font-medium">Privacybeleid</span>
          </nav>

          <h1 class="text-[2rem] font-extrabold text-[#111] mb-2 leading-tight">Privacybeleid</h1>
          <p class="text-[0.82rem] text-[#aaa] mb-8">Laatste update: mei 2025</p>

          <div class="prose-content">

            <h2>1. Wie zijn wij?</h2>
            <p>Plug2Charge B.V. ("Plug2Charge", "wij", "ons") is verantwoordelijk voor de verwerking van persoonsgegevens zoals beschreven in dit privacybeleid. Wij zijn te bereiken via <a href="mailto:info@plug2charge.nl">info@plug2charge.nl</a>.</p>

            <h2>2. Welke gegevens verzamelen wij?</h2>
            <p>Bij het plaatsen van een bestelling of het aanmaken van een account verzamelen wij:</p>
            <ul>
              <li>Naam, adres en contactgegevens (e-mail, telefoon)</li>
              <li>Bestel- en betalingsgegevens</li>
              <li>Communicatie die je met ons deelt</li>
            </ul>
            <p>Technische gegevens (IP-adres, browser, cookies) worden automatisch verzameld via onze website.</p>

            <h2>3. Waarom verwerken wij jouw gegevens?</h2>
            <ul>
              <li><strong>Uitvoering overeenkomst:</strong> om je bestelling te verwerken en te leveren</li>
              <li><strong>Wettelijke verplichting:</strong> voor boekhoud- en belastingdoeleinden</li>
              <li><strong>Gerechtvaardigd belang:</strong> voor fraude­preventie en website­optimalisatie</li>
              <li><strong>Toestemming:</strong> voor het versturen van nieuwsbrieven (uitschrijven kan altijd)</li>
            </ul>

            <h2>4. Met wie delen wij jouw gegevens?</h2>
            <p>Wij delen gegevens alleen met partijen die noodzakelijk zijn voor de uitvoering van onze dienstverlening, zoals bezorgdiensten en betaalpartners. Wij verkopen jouw gegevens nooit aan derden.</p>

            <h2>5. Hoe lang bewaren wij jouw gegevens?</h2>
            <p>Wij bewaren persoonsgegevens niet langer dan noodzakelijk. Bestelgegevens worden minimaal 7 jaar bewaard op grond van fiscale wetgeving. Account­gegevens worden bewaard zolang je een account bij ons hebt.</p>

            <h2>6. Jouw rechten</h2>
            <p>Je hebt het recht op inzage, correctie, verwijdering, beperking en overdraagbaarheid van jouw gegevens. Stuur hiervoor een e-mail naar <a href="mailto:info@plug2charge.nl">info@plug2charge.nl</a>. Je kunt ook een klacht indienen bij de Autoriteit Persoonsgegevens.</p>

            <h2>7. Beveiliging</h2>
            <p>Wij nemen passende technische en organisatorische maatregelen om jouw gegevens te beveiligen tegen ongeoorloofde toegang of verlies.</p>

            <h2>8. Cookies</h2>
            <p>Wij gebruiken cookies. Zie ons <router-link to="/cookies">cookiebeleid</router-link> voor meer informatie.</p>

            <h2>9. Wijzigingen</h2>
            <p>Wij kunnen dit privacybeleid aanpassen. De meest recente versie staat altijd op deze pagina.</p>

          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script setup></script>

<style scoped>
.prose-content :deep(h2) { font-size: 1.125rem; font-weight: 700; color: #111; margin-top: 1.75rem; margin-bottom: 0.625rem; padding-bottom: 0.375rem; border-bottom: 1px solid #f0f0f0; }
.prose-content :deep(p)  { font-size: 0.9375rem; color: #444; line-height: 1.7; margin-bottom: 0.875rem; }
.prose-content :deep(ul) { padding-left: 1.25rem; margin-bottom: 0.875rem; }
.prose-content :deep(li) { font-size: 0.9375rem; color: #444; list-style-type: disc; margin-bottom: 0.375rem; }
.prose-content :deep(a)  { color: #b8860b; text-decoration: underline; }
.prose-content :deep(a:hover) { color: #111; }
.prose-content :deep(strong) { font-weight: 700; color: #333; }
</style>
